module.exports = __webpack_public_path__ + "img/SmartCollege_mehrfarbig_RGB.59f761e1.svg";